import React,{ useEffect, useState } from "react"
import { useHourlyActiveUser } from "../../hooks/useHourlyActiveUser"
import moment from "moment"
import _ from 'lodash'
import ReactECharts from 'echarts-for-react';
import active_user_bg from './img/active_user.svg'
import * as echarts from 'echarts/core';
import { blue } from "../../theme/colors";
import { useHitRate } from "../../hooks/useHitRate";
// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import prediction_accuracy from './img/prediction_accuracy.svg'
import { useTranslation } from "react-i18next";

export const HitRatePanel = ()=>{
    const {data:hitRates,refresh} = useHitRate()
    const [chartData,setChartData] = useState<number[]>()
    const [xAxisData,setXAxisData]= useState<string[]>()
    const [rate,setRate] = useState(0)
    useEffect(()=>{
      let i = setInterval(() => {
        // setRate(_.random(80,96))
        refresh()
      }, 60*1000);
      return ()=>clearInterval(i)
    })
    useEffect(()=>{
      if(!hitRates){
        return
      }
      if(hitRates.length>0){
        const hr = hitRates[0].hitRate
        if(hr){
          setRate(hr)
        }
      }
      
    },[hitRates])
    const {t} = useTranslation()
    if(!rate){ 
      return <></>
    }
    return <div style={{alignSelf:'stretch',position:'relative'}}>
      <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontWeight:'bold'}}> 
        <img src={prediction_accuracy} style={{width:20,height:20,marginLeft:10,marginRight:10}}/>{t('Prediction Accuracy')}
      </div>
      <div style={{alignSelf:'stretch',backgroundColor:'white',borderRadius:10,margin:10,height:210,boxShadow:'0px 6px 12px rgba(0, 0, 0, 0.08)'}}>
        
        {rate && <ReactECharts option={{
       series: [
        {
          type: 'gauge',
          center: ['50%', '45%'],
          startAngle: 190,
          endAngle: -10,
          min: 0,
          max: 100,
          splitNumber: 10,
          itemStyle: {
            color: '#F9BC00'
          },
          
          progress: {
            show: true,
            roundCap:false,
            width: 30
          },
          pointer: {
            show: true,
            length: '65%',
            itemStyle: {
              color: 'white',
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0
            },
            icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
          },
          axisLine: {
            lineStyle: {
              width: 30,
              color: [[1, '#3CCFA3']]
            }
          },
          axisTick: {
            distance: -20,
            splitNumber: 5,
            lineStyle: {
              width: 0,
              color: 'tomato'
            }
          },
          splitLine: {
            distance: 0,
            length: 5,
            // z: 100,
            lineStyle: {
              width: 1,
              color: 'lightgray'
            }
          },
          axisLabel: {
            distance: -20,
            color: 'transparent',
            fontSize: 20
          },
          anchor: {
            show: false 
          },
          title: {
            show: false
          },
          detail:{
            color:'transparent'
          },
          // detail: {
          //   valueAnimation: true,
          //   width: '60%',
          //   lineHeight: 40,
          //   borderRadius: 800,
          //   offsetCenter: [0, '-15%'],
          //   fontSize: 20,

          //   shadowColor: 'rgba(0,138,255,0.45)',
          //   shadowBlur: 10,
          //   shadowOffsetX: 2,
          //   shadowOffsetY: 2,
            
          //   color:'black',
          //   fontWeight: 'bolder',
          //   formatter: '{value}%',
          // },
          data: [
            {
              value: rate
            }
          ]
        } 
      ]
      }} />}
      </div>
      <div style={{
        position:'absolute',top:'45%',left:0,right:0,
        display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'
        // overflow:'hidden'
      }}>
          <div style={{ 
          boxShadow:' 0px -5.59px 5.34px 0px rgba(0, 0, 0, 0.05)',
          // boxShadow:' 0px -3.59px 3.34px 0px rgba(0, 0, 0, 0.2)',
          borderTopRightRadius:80,borderTopLeftRadius:80,background:'white',width:110,height:70,textAlign:'center',paddingTop:5}}>
          <div style={{fontWeight:'bold',fontSize:25}}>{rate}%</div>
          <div style={{fontSize:12,lineHeight:'90%',textOverflow:'clip', textWrap:'wrap',whiteSpace:'wrap'}}>
            {t('Prediction Accuracy')}</div>
          </div>
          <div style={{fontSize:14,background:blue[100],color:blue[900],borderRadius:100,paddingLeft:10,paddingRight:10,marginTop:10}}>
            {t('View Prediction Details')}
          </div>
      </div>
     
    </div>
  }